export const leadConversationsStrings = {
  title: "Conversaciones IA de leads",
  subtitle:
    "Revisa lo que cada lead respondió al asistente de WhatsApp, reinicia el flujo o elimina la conversación.",
  searchLabel: "Buscar por teléfono, nombre o proyecto",
  statusLabel: "Estado",
  stepLabel: "Paso",
  allOption: "Todos",
  searchButton: "Buscar",
  resultCount: (total: number) => `${total} conversación${total === 1 ? "" : "es"}`,
  colCustomer: "Cliente",
  colProject: "Proyecto",
  colStep: "Paso",
  colStatus: "Estado",
  colScore: "Puntaje",
  colLastMessage: "Último mensaje",
  allProjects: "Todos los proyectos",
  noProject: "Sin proyecto aún",
  emptyTitle: "No hay conversaciones con estos filtros",
  emptyHint:
    "Cuando un lead escriba a la línea de WhatsApp de leads, su conversación aparecerá aquí.",
  loadError: "No se pudieron cargar las conversaciones.",
  retry: "Reintentar",
  scoreValue: (score: number, max: number) => `${score}/${max}`,
  priority: {
    3: "Prioridad alta",
    2: "Prioridad media",
    1: "Prioridad baja",
  } as Record<number, string>,
  status: {
    active: "En conversación",
    scheduled: "Llamada agendada",
    disqualified: "No quiso agendar",
    abandoned: "Sin respuesta",
  },
  step: {
    initial: "Inicio",
    ask_project: "Pregunta proyecto",
    ask_lot_range: "Pregunta lote",
    ask_payment: "Pregunta pago",
    ask_schedule: "Pregunta horario",
    ask_call_slot: "Elige hora de llamada",
    reminder_sent: "Recordatorio enviado",
    scheduled: "Agendado",
    closed: "Cerrado",
  },
  drawerTitle: "Conversación con el asistente",
  scheduleStripTitle: "Llamada agendada",
  scheduleStripAgenda: "Ver agenda de llamadas",
  scheduleStatus: {
    pending: "Pendiente",
    done: "Hecha",
    cancelled: "Cancelada",
  } as Record<string, string>,
  close: "Cerrar",
  loadOlder: "Cargar mensajes anteriores",
  messagesEmpty: "Esta conversación aún no tiene mensajes.",
  messagesLoadError: "No se pudo cargar la conversación.",
  botLabel: "Asistente",
  notDelivered: "No entregado",
  attachment: "Ver adjunto",
  restartAction: "Reiniciar flujo",
  deleteAction: "Eliminar conversación",
  restartTitle: "¿Reiniciar el flujo de este lead?",
  restartBody:
    "Se borran las respuestas y el puntaje, y se envía de nuevo el saludo con la lista de proyectos. Si el último mensaje del lead tiene más de 24 horas, WhatsApp no permite escribirle: el flujo se reinicia cuando vuelva a escribir.",
  restartConfirm: "Reiniciar",
  deleteTitle: "¿Eliminar esta conversación?",
  deleteBody:
    "Se eliminan la sesión y todos sus mensajes. No se puede deshacer. Si el lead vuelve a escribir, empieza un flujo nuevo.",
  deleteConfirm: "Eliminar",
  cancel: "Cancelar",
  restartSent: "Flujo reiniciado. Se envió el saludo al lead.",
  restartNotSent: "Flujo reiniciado. Se enviará el saludo cuando el lead vuelva a escribir (ventana de 24 h cerrada).",
  deleted: "Conversación eliminada.",
  actionError: "No se pudo completar la acción.",
} as const
